import state from "./state";
import { useSnapshot } from "valtio";
import "./Conversion.css";

export default function Convertion() {
  const snape = useSnapshot(state);

  function showUnit(event) {
    event.preventDefault();

    if (snape.unit === "celsius") {
      state.unit = "fahrenheit";
    } else {
      state.unit = "celsius";
    }
  }

  if (state.unit === "celsius") {
    return (
      <div className="Conversion">
        ºC /{" "}
        <a href="/" onClick={showUnit}>
          ºF
        </a>
      </div>
    );
  } else {
    return (
      <div className="Conversion">
        <a href="/" onClick={showUnit}>
          ºC
        </a>{" "}
        / ºF
      </div>
    );
  }
}
